import Logo from "./Logo";
import { Send } from "lucide-react";
import { TELEGRAM_URL, TELEGRAM_HANDLE, DERIV_AFFILIATE_URL } from "@/lib/socialLinks";

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-vts-line bg-black"
    >
      <div className="mx-auto max-w-7xl px-5 lg:px-8 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <Logo size="lg" />
            <p className="mt-5 text-sm text-vts-silver/70 max-w-sm leading-relaxed font-body">
              VTS — Forex, Gold &amp; Crypto Trading Desk. A beginner-friendly automated
              trading platform powered by the Deriv API. Built by official Deriv partners.
            </p>
            <div className="mt-6 text-xs text-vts-silver/40 font-mono">
              Streaming live from ws.derivws.com
            </div>
          </div>

          <div className="lg:col-span-7 grid grid-cols-2 sm:grid-cols-4 gap-8">
            <div>
              <div className="text-xs uppercase tracking-[0.2em] text-vts-silver/50 mb-4 font-semibold">
                Platform
              </div>
              <ul className="space-y-2.5 text-sm text-vts-silver/80">
                <li><a href="#markets" className="hover:text-white transition">Markets</a></li>
                <li><a href="#platforms" className="hover:text-white transition">Platforms</a></li>
                <li><a href="#how" className="hover:text-white transition">How it works</a></li>
                <li><a href="/trade" className="hover:text-white transition">Trade Desk</a></li>
              </ul>
            </div>
            <div>
              <div className="text-xs uppercase tracking-[0.2em] text-vts-silver/50 mb-4 font-semibold">
                Community
              </div>
              <ul className="space-y-2.5 text-sm text-vts-silver/80">
                <li>
                  <a
                    data-testid="footer-telegram-link"
                    href={TELEGRAM_URL}
                    target="_blank"
                    rel="noreferrer noopener"
                    className="hover:text-white transition inline-flex items-center gap-1.5"
                  >
                    <Send className="h-3 w-3 text-[#229ED9]" /> Telegram channel
                  </a>
                </li>
                <li>
                  <a
                    href={TELEGRAM_URL}
                    target="_blank"
                    rel="noreferrer noopener"
                    className="hover:text-white transition text-[10px] font-mono text-vts-silver/60 break-all"
                  >
                    {TELEGRAM_HANDLE}
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <div className="text-xs uppercase tracking-[0.2em] text-vts-silver/50 mb-4 font-semibold">
                Resources
              </div>
              <ul className="space-y-2.5 text-sm text-vts-silver/80">
                <li><a href={DERIV_AFFILIATE_URL} target="_blank" rel="noreferrer" className="hover:text-white transition">Deriv.com</a></li>
                <li><a href="https://developers.deriv.com" target="_blank" rel="noreferrer" className="hover:text-white transition">Deriv API Docs</a></li>
                <li><a href="#faq" className="hover:text-white transition">FAQ</a></li>
              </ul>
            </div>
            <div>
              <div className="text-xs uppercase tracking-[0.2em] text-vts-silver/50 mb-4 font-semibold">
                Legal
              </div>
              <ul className="space-y-2.5 text-sm text-vts-silver/80">
                <li><a href="#" className="hover:text-white transition">Terms</a></li>
                <li><a href="#" className="hover:text-white transition">Privacy</a></li>
                <li><a href="#" className="hover:text-white transition">Risk disclosure</a></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-vts-line">
          <div className="text-xs text-vts-silver/50 leading-relaxed font-body max-w-4xl mb-6">
            <span className="text-vts-silver/80 font-medium">Risk warning.</span>{" "}
            Trading derivatives carries a high level of risk and may not be
            suitable for all investors. You may lose all of your invested
            capital. VTS is an introducing partner of Deriv and earns a
            commission on trades placed through this platform. VTS is not a
            broker and does not custody client funds.
          </div>
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 text-xs text-vts-silver/50">
            <div>© {year} VTS — Forex, Gold &amp; Crypto Trading Desk. All rights reserved.</div>
            <div className="font-mono">v1.0 · Deriv Partner Program</div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
